import { Component, input, computed } from '@angular/core';

@Component({
  selector: 'ui-phase-indicator',
  template: `
    @if (phase()) {
      <div [class]="dynamicClasses()">
        {{ phase() }}
      </div>
    } @else {
      <span>--</span>
    }
  `,
})
export class PhaseIndicatorComponent {
  phase = input.required<string>();

  protected readonly DEFAULT_CLASSES =
    'rounded-full flex items-center justify-center aspect-square w-6 border';

  private readonly phaseStyleMap: Record<string, string> = {
    R: 'border-phase-3-50 bg-phase-3-25 text-phase-3-100',
    S: 'border-phase-1-50 bg-phase-1-25 text-phase-1-100',
    T: 'border-phase-2-50 bg-phase-2-25 text-phase-2-100',
  };

  dynamicClasses = computed(() =>
    this.phase()
      ? `${this.phaseStyleMap[this.phase()!]} ${this.DEFAULT_CLASSES}`
      : '',
  );
}
